import { useEffect, useRef } from 'react';

// Returns a ref that contains information about
// mount state of a component
const useIsMountedRef = () => {
  const isMountedRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  return isMountedRef;
};

export default useIsMountedRef;
